import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
import { assertIdentifier, assertRegion, assertRegionListener } from "./validation";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneLocation");
  return hybrid;
}
function getPermissionStatus() {
  try {
    return native().getPermissionStatus();
  } catch (error) {
    return rethrowNativeError(error);
  }
}
function requestWhenInUsePermission() {
  return native().requestWhenInUsePermission().catch(rethrowNativeError);
}
function requestAlwaysAuthorization() {
  return native().requestAlwaysAuthorization().catch(rethrowNativeError);
}
function getCurrentPosition() {
  return native().getCurrentPosition().catch(rethrowNativeError);
}
function watchPosition(onPosition, onError) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return native().addPositionListener(onPosition, function(code, message) {
    onError(Object.assign(new Error(message), {
      code
    }));
  }, options.background === true);
}
function geocodeAddress(address) {
  return native().geocodeAddress(address).catch(rethrowNativeError);
}
function reverseGeocode(latitude, longitude) {
  return native().reverseGeocode(latitude, longitude).catch(rethrowNativeError);
}
function startMonitoring(region) {
  assertRegion(region, "startMonitoring");
  return native().startMonitoring(region).catch(rethrowNativeError);
}
function stopMonitoring(identifier) {
  assertIdentifier(identifier, "stopMonitoring");
  return native().stopMonitoring(identifier).catch(rethrowNativeError);
}
function monitoredRegions() {
  try {
    return native().monitoredRegions();
  } catch (error) {
    return rethrowNativeError(error);
  }
}
function requestState(identifier) {
  assertIdentifier(identifier, "requestState");
  return native().requestState(identifier).catch(rethrowNativeError);
}
function addDidEnterRegionListener(listener) {
  assertRegionListener(listener, "addDidEnterRegionListener");
  var remove = native().addDidEnterRegionListener(listener);
  return {
    remove: function remove1() {
      return remove();
    }
  };
}
function addDidExitRegionListener(listener) {
  assertRegionListener(listener, "addDidExitRegionListener");
  var remove = native().addDidExitRegionListener(listener);
  return {
    remove: function remove1() {
      return remove();
    }
  };
}
var Location = Object.freeze({
  getPermissionStatus,
  requestWhenInUsePermission,
  requestAlwaysAuthorization,
  getCurrentPosition,
  watchPosition,
  geocodeAddress,
  reverseGeocode,
  startMonitoring,
  stopMonitoring,
  monitoredRegions,
  requestState,
  addDidEnterRegionListener,
  addDidExitRegionListener
});
export {
  Location
};
//# sourceMappingURL=index.native.js.map
